import {
  Mail, AlertTriangle, ClipboardList, Receipt, Shield,
  FileCheck, FileText, File, Check, PowerOff, Archive, Edit,
  Building, Users, Briefcase
} from 'lucide-react';

// Catégories de modèles
export const TEMPLATE_CATEGORIES = [
  { id: 'courrier', label: 'Courriers', icon: Mail, color: 'bg-blue-600' },
  { id: 'declaration', label: 'Déclarations Dommages', icon: AlertTriangle, color: 'bg-red-600' },
  { id: 'rapport', label: 'Rapports Expertise', icon: ClipboardList, color: 'bg-purple-600' },
  { id: 'relance', label: 'Relances Factures', icon: Receipt, color: 'bg-orange-600' },
  { id: 'convention', label: 'Conventions', icon: Shield, color: 'bg-green-600' },
  { id: 'attestation', label: 'Attestations', icon: FileCheck, color: 'bg-cyan-600' },
  { id: 'contrat', label: 'Contrats', icon: FileText, color: 'bg-indigo-600' },
  { id: 'autre', label: 'Autres', icon: File, color: 'bg-gray-600' },
];

// Statuts des modèles
export const TEMPLATE_STATUS = {
  active: { label: 'Actif', color: 'bg-green-700', icon: Check },
  inactive: { label: 'Inactif', color: 'bg-gray-600', icon: PowerOff },
  archived: { label: 'Archivé', color: 'bg-amber-700', icon: Archive },
  draft: { label: 'Brouillon', color: 'bg-blue-600', icon: Edit },
};

// Types de tampons
export const STAMP_TYPES = [
  { id: 'official', label: 'Officiel', color: 'bg-blue-600' },
  { id: 'certification', label: 'Certification', color: 'bg-green-600' },
  { id: 'expert', label: 'Expert', color: 'bg-purple-600' },
  { id: 'custom', label: 'Personnalisé', color: 'bg-orange-600' },
];

// Destinataires possibles
export const RECIPIENTS = [
  { id: 'coopers', label: "COOPER'S", icon: Building, color: 'bg-purple-600' },
  { id: 'members', label: 'Membres', icon: Users, color: 'bg-green-600' },
  { id: 'experts', label: 'Experts', icon: Briefcase, color: 'bg-orange-600' },
];

// Modèles par défaut
export const DEFAULT_TEMPLATES = [
  { 
    id: 1, 
    name: 'Déclaration de dommage', 
    category: 'declaration',
    status: 'active',
    description: 'Formulaire standard de déclaration de dommage',
    createdBy: 'Système',
    createdAt: '2024-01-15',
    updatedAt: '2024-12-01',
    usageCount: 156,
    sharedWith: ['coopers', 'members'],
    stampId: null,
    content: `<div style="font-family: Arial, sans-serif; padding: 20px;">
<div style="text-align: center; margin-bottom: 30px;">
<h1 style="color: #1e3a5f; margin-bottom: 5px;">DÉCLARATION DE DOMMAGE</h1>
<p style="color: #666;">Référence : {{reference}}</p>
</div>

<div style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin-bottom: 20px;">
<h3 style="color: #1e3a5f; margin-top: 0;">Informations du déclarant</h3>
<p><strong>Nom :</strong> {{nom}}</p>
<p><strong>Prénom :</strong> {{prenom}}</p>
<p><strong>Adresse :</strong> {{adresse}}</p>
<p><strong>Téléphone :</strong> {{telephone}}</p>
<p><strong>Email :</strong> {{email}}</p>
</div>

<div style="margin-bottom: 20px;">
<h3 style="color: #1e3a5f;">Description du dommage</h3>
<p><strong>Date du dommage :</strong> {{date_dommage}}</p>
<p><strong>Lieu :</strong> {{lieu_dommage}}</p>
<p><strong>Description :</strong></p>
<p style="background: #fff; border: 1px solid #ddd; padding: 15px; border-radius: 4px;">{{description}}</p>
</div>

<div style="margin-bottom: 20px;">
<h3 style="color: #1e3a5f;">Pièces jointes</h3>
<ul>{{pieces_jointes}}</ul>
</div>

<div style="margin-top: 40px; border-top: 2px solid #1e3a5f; padding-top: 20px;">
<p><strong>Date :</strong> {{date}}</p>
<p><strong>Signature du déclarant :</strong></p>
<div style="height: 80px; border-bottom: 1px solid #333; width: 300px;"></div>
</div>

{{BLOC_SIGNATURE}}
</div>`
  },
  { 
    id: 2, 
    name: "Rapport d'expertise", 
    category: 'rapport',
    status: 'active',
    description: "Modèle de rapport d'expertise technique complet",
    createdBy: 'Système',
    createdAt: '2024-01-15',
    updatedAt: '2024-11-20',
    usageCount: 89,
    sharedWith: ['experts'],
    stampId: 1,
    content: `<div style="font-family: Arial, sans-serif; padding: 20px;">
<div style="text-align: center; border-bottom: 3px solid #1e3a5f; padding-bottom: 20px; margin-bottom: 30px;">
<h1 style="color: #1e3a5f; margin-bottom: 5px;">RAPPORT D'EXPERTISE</h1>
<p style="color: #666; font-size: 14px;">N° Dossier : {{numero_dossier}}</p>
<p style="color: #666; font-size: 14px;">Date de visite : {{date_visite}}</p>
</div>

<section style="margin-bottom: 25px;">
<h2 style="color: #1e3a5f; border-left: 4px solid #c9a227; padding-left: 10px;">1. Objet de l'expertise</h2>
<p>{{objet}}</p>
</section>

<section style="margin-bottom: 25px;">
<h2 style="color: #1e3a5f; border-left: 4px solid #c9a227; padding-left: 10px;">2. Constatations</h2>
<p>{{constatations}}</p>
</section>

<section style="margin-bottom: 25px;">
<h2 style="color: #1e3a5f; border-left: 4px solid #c9a227; padding-left: 10px;">3. Conclusions</h2>
<p>{{conclusions}}</p>
</section>

{{BLOC_SIGNATURE}}
</div>`
  },
  { 
    id: 3, 
    name: 'Relance facture impayée', 
    category: 'relance',
    status: 'active',
    description: 'Première relance pour facture impayée',
    createdBy: 'Système',
    createdAt: '2024-01-15',
    updatedAt: '2024-10-15',
    usageCount: 234,
    sharedWith: ['coopers'],
    stampId: null,
    content: `<div style="font-family: Arial, sans-serif; padding: 30px; max-width: 700px; margin: 0 auto;">
<div style="text-align: right; margin-bottom: 40px;">
<p style="margin: 0;">{{lieu}}, le {{date}}</p>
</div>

<div style="margin-bottom: 30px;">
<p style="margin: 0;"><strong>{{destinataire_nom}}</strong></p>
<p style="margin: 0;">{{destinataire_adresse}}</p>
</div>

<p style="margin-bottom: 20px;"><strong>Objet : Relance facture n°{{facture_numero}}</strong></p>

<p>Madame, Monsieur,</p>

<p>Sauf erreur de notre part, nous constatons que la facture n°<strong>{{facture_numero}}</strong> d'un montant de <strong>{{montant}} €</strong> reste impayée à ce jour.</p>

<p>Nous vous remercions de bien vouloir procéder à son règlement dans les <strong>8 jours</strong>.</p>

<p style="margin-top: 30px;">Veuillez agréer, Madame, Monsieur, l'expression de nos salutations distinguées.</p>

{{BLOC_SIGNATURE}}
</div>`
  },
  { 
    id: 4, 
    name: "Courrier d'accompagnement", 
    category: 'courrier',
    status: 'active',
    description: "Courrier standard d'accompagnement de documents",
    createdBy: 'Système',
    createdAt: '2024-01-15',
    updatedAt: '2024-09-01',
    usageCount: 312,
    sharedWith: ['coopers', 'members', 'experts'],
    stampId: null,
    content: `<div style="font-family: Arial, sans-serif; padding: 30px; max-width: 700px; margin: 0 auto;">
<div style="text-align: right; margin-bottom: 40px;">
<p style="margin: 0;">{{lieu}}, le {{date}}</p>
</div>

<div style="margin-bottom: 30px;">
<p style="margin: 0;"><strong>{{destinataire}}</strong></p>
<p style="margin: 0;">{{destinataire_adresse}}</p>
</div>

<p style="margin-bottom: 20px;"><strong>Objet :</strong> {{objet}}</p>

<p>Madame, Monsieur,</p>

<p>{{corps}}</p>

<p>Vous trouverez ci-joint les documents suivants :</p>
<ul>
{{liste_documents}}
</ul>

<p style="margin-top: 30px;">Veuillez agréer, Madame, Monsieur, l'expression de nos salutations distinguées.</p>

{{BLOC_SIGNATURE}}
</div>`
  },
  { 
    id: 5, 
    name: 'Attestation de garantie RCDS', 
    category: 'attestation',
    status: 'active',
    description: 'Attestation officielle de couverture RCDS',
    createdBy: 'Système',
    createdAt: '2024-02-01',
    updatedAt: '2024-12-10',
    usageCount: 78,
    sharedWith: ['members'],
    stampId: 2,
    content: `<div style="font-family: Arial, sans-serif; padding: 30px; max-width: 700px; margin: 0 auto; border: 2px solid #1e3a5f;">
<div style="text-align: center; margin-bottom: 30px; border-bottom: 2px solid #c9a227; padding-bottom: 20px;">
<h1 style="color: #1e3a5f; margin-bottom: 5px;">ATTESTATION DE GARANTIE</h1>
<h2 style="color: #c9a227; font-weight: normal;">Responsabilité Civile Décennale Solidaire</h2>
</div>

<p style="text-align: center; font-style: italic; margin-bottom: 30px;">
Attestation n° {{numero_attestation}}
</p>

<p>Nous soussignés, <strong>O'SCOP</strong>, certifions que :</p>

<div style="background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0;">
<p style="margin: 5px 0;"><strong>Entreprise :</strong> {{entreprise_nom}}</p>
<p style="margin: 5px 0;"><strong>SIRET :</strong> {{siret}}</p>
<p style="margin: 5px 0;"><strong>Adresse :</strong> {{adresse}}</p>
</div>

<p><strong>Période de validité :</strong> Du {{date_debut}} au {{date_fin}}</p>

<div style="margin-top: 40px;">
<p>Fait à {{lieu}}, le {{date}}</p>
</div>

{{BLOC_SIGNATURE}}
</div>`
  },
];

// Collection de tampons par défaut (fallback si API non disponible)
export const DEFAULT_STAMPS = [
  { id: 1, name: "Tampon Officiel O'SCOP", image: '/logos/oscop_stamp.png', type: 'official', assignedTo: ['rapport', 'attestation', 'convention'] },
  { id: 2, name: 'Tampon RCDS Certifié', image: '/logos/rcds_stamp.png', type: 'certification', assignedTo: ['attestation'] },
  { id: 3, name: "Tampon COOPER'S Advisor Agréé", image: '/logos/expert_stamp.png', type: 'expert', assignedTo: ['rapport'] },
];

// Helpers
export const getCategoryInfo = (categoryId) => {
  return TEMPLATE_CATEGORIES.find(c => c.id === categoryId) || TEMPLATE_CATEGORIES[7];
};

export const getStampTypeInfo = (typeId) => {
  return STAMP_TYPES.find(t => t.id === typeId) || STAMP_TYPES[3];
};
